<script lang="ts">
	import type { SbImage } from '../types';
	import Image from '../components/image.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			asset: SbImage;
			body: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="relative">
	<Image
		class="h-full w-full object-cover object-center"
		src={content.asset.filename}
		alt={content.asset.alt}
		title={content.asset.title}
	/>
	<div class="absolute inset-0 z-10">
		{#each content.body as block}
			<Blok content={block} />
		{/each}
	</div>
</div>
